enum ModalidadeFrete {
    PorContaDoEmitente = 0,
    PorContaDoDestinatarioRemetente = 1,
    PorContaDeTerceiros = 2,
    TransporteProprioPorContaDoRemetente = 3,
    TransporteProprioPorContaDoDestinatario = 4,
    SemFrete = 9,
}

export default ModalidadeFrete;
